import React from 'react';
import { useTranslation } from 'react-i18next';
import WhatsappLogo from '../../assets/img/home/logo-whatsapp.png';

const WhatsappButton = () => {
    const { t } = useTranslation('whatsapp'); // Usando o namespace 'whatsapp'

    return (
        <a href="https://api.whatsapp.com/send?phone=5521983372459" target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
            <img className="whats-img" src={WhatsappLogo} alt="Ícone do Whatsapp" />
            <span className="span-whatsapp">
                {t('message')}
            </span>
        </a>
    );
};

export default WhatsappButton;
